import userRoles from 'app/userRoles';
import React from 'react';

const ProfileConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: null,
  routes: [
    {
      path: '/profile',
      exact: true,
      component: React.lazy(() => import('.'))
    }
  ]
};

const ManagersConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: [userRoles.FRANCHISEE_ACCOUNT_MANAGERS_LIST],
  routes: [
    {
      path: '/profile/managers',
      exact: true,
      component: React.lazy(() => import('./managers'))
    }
  ]
};

const CustomRequestConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: ['ROLE_SALON', 'ROLE_SALON_LIST', 'ROLE_SUPER_ADMIN'],
  routes: [
    {
      path: '/profile/custom-request',
      exact: true,
      component: React.lazy(() => import('./custom_request'))
    }
  ]
};

export { ProfileConfig, ManagersConfig, CustomRequestConfig };
